var _circle, _circle2, _circle3, _path, _path2, _g, _g2, _g3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSam = function SvgSam(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 85 85",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 40,
    fill: "#00698f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 37.726,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9baeab",
    d: "M42.5 80.226c15.281 0 28.429-9.09 34.36-22.153-6.265-12.513-12.527-25.02-18.803-37.551-1.838.688-3.538 1.331-5.257 1.975-3.594-5.551-7.144-11.026-10.745-16.577-.275.419-.488.719-.681 1.025-5.257 8.338-10.582 16.633-15.721 25.034-1.431 2.338-3.063 4.119-5.763 4.919-.544.162-1.1.763-1.369 1.3-3.418 6.731-6.82 13.473-10.228 20.212C14.295 71.292 27.351 80.226 42.5 80.226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00698f",
    d: "m51.131 60.318 7.004-12.008-15.118-25.424L27.419 49.09l6.477 11.247 8.628-11.963z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00837b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.421 43.974-10.319 17.69 9.584 13.299a37.9 37.9 0 0 0 12.163-11.498zM61.235 75.237l.001.002.056-.034zM74.033 63.203l.002-.004z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#006e43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.073 75.329q.036-.02.073-.039l-.002-.002zM23.854 75.287l-.002.002.086.046-.085-.048ZM42.523 50.967 24.669 75.722c5.313 2.859 11.375 4.504 17.831 4.504s12.535-1.649 17.854-4.516z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#009d4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.562 62.563-.002.003q.035.053.071.105zM23.787 75.249q.041.025.083.051l.002-.003-.085-.049ZM32.922 61.687 22.538 43.652 11.106 63.379a37.9 37.9 0 0 0 12.232 11.596z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.094 63.4 11.444-19.749 10.384 18.035-9.594 13.302q.654.39 1.326.754l17.869-24.775 17.845 24.764a38 38 0 0 0 1.325-.755l-9.592-13.311 10.319-17.69 11.435 19.504q.475-.706.918-1.433L62.416 40.971l-3.408 5.843-15.991-26.893-16.466 27.664-4.009-6.963-12.365 21.339q.442.732.917 1.441Zm31.923-40.514 15.118 25.425-7.004 12.008-8.607-11.944-8.628 11.963-6.476-11.247 15.598-26.205Z"
  })));
};
export default SvgSam;